var compare_price_map = {};
var activeBannerswiper = new Swiper(".activeBannerSwiper", {
  autoplay: true,
  loop: true,
});

var module1VideoSwiper = new Swiper(".module1VideoSwiper", {
  spaceBetween: 30,
});

// 加载 YouTube IFrame API 的 SDK
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// 创建播放器对象
var player;
function onYouTubeIframeAPIReady() {
  let lang = $('#player').data('lang');
  let url = '';
  if (lang == 'fr') {
    url = $('#player').data('url-fr');
  } else if (lang == 'de') {
    url = $('#player').data('url-de');
  } else {
    url = $('#player').data('url');
  }
 
  player = new YT.Player('player', {
    height: isMobile() ? '240' : '480',
    width: isMobile() ? '375' : '1200',
    videoId: getYouTubeVideoId(url)
  });
}

// 在文档加载完成后，找到按钮并添加事件监听器
window.onload = function () {
  $('.video-box-play-icon').on('click', function () {
    $('.video-cover').hide();
    $(this).parent().hide();
    // 播放视频
    player.playVideo();
  });
};

function getYouTubeVideoId(url) {
  var videoId = "";
  var pattern = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
  var match = url.match(pattern);
  if (match && match[1]) {
    videoId = match[1];
  }
  return videoId;
}

// $('.video-box-play-icon').on('click', function () {
//     let video = $(this).parent().parent().find('video');

//     if (video[0].paused) {
//         module1VideoSwiper.autoplay.stop();
//         video.attr('controls', true);
//         video[0].play();
//         $(this).parent().hide();
//     }
//     video.on("pause", function (e) {
//         $(this).parent().find('.video-box-play').show();
//         video.attr('controls', false);
//     });
// });

var activeSwiper = new Swiper(".activeSwiper", {
  pagination: {
    el: ".product-buy-card .swiper-pagination",
    type: isMobile() ? "bullets" : "fraction",
  },
  navigation: {
    nextEl: ".active-swiper-button-next",
    prevEl: ".active-swiper-button-prev",
  },
  on: {
    init: function () {

    }
  }
});


var socialSlide = new Swiper(".tb-product-social-media-swiper", {
  spaceBetween: 30,
  slidesPerView: isMobile() ? 1 : 3,
  autoplay: true,
  slidesPerGroup: isMobile() ? 1 : 3,
  pagination: {
    el: ".tb-product-social-media-swiper .swiper-pagination",
  },
  lazy: {
    loadPrevNext: true,
  }
});
$(window).resize(function () {
  var ww = $(window).width()
  if (ww <= 768) {
    socialSlide.params.slidesPerView = 1;
    socialSlide.params.slidesPerGroup = 1;
  }
  if (ww > 768) {
    socialSlide.params.slidesPerView = 3;
    socialSlide.params.slidesPerGroup = 3;
  }
  socialSlide.update()
});

var reviewSwiper = new Swiper(".review-swiper", {
  spaceBetween: isMobile() ? 20 : 40,
  centeredSlides: isMobile() ? false : true,
  loop: true,
  slidesPerView: isMobile() ? 1.1 : 1.5,
  pagination: {
    el: ".review-card .swiper-pagination",
  }
});

$('.faq-box dt').click(function () {
  $(this).next().slideToggle();
  $(this).toggleClass('active')
})

// let scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js'

// if (!window.ShopifyBuyInitialized) {
//   if (window.ShopifyBuy) {
//     if (window.ShopifyBuy.UI) {
//       window.ShopifyBuyInitialized = true; // 设置标志位
//       ShopifyBuyInit();
//     } else {
//       window.ShopifyBuyInitialized = true; // 设置标志位
//       console.log(1);
//       loadScript2();
//     }
//   } else {
//     console.log(2);
//     window.ShopifyBuyInitialized = true; // 设置标志位
//     loadScript2();
//   }
// }

// function loadScript2() {
//   console.log('loadScript')
//   var script = document.createElement('script');
//   script.async = true;
//   script.src = scriptURL;
//   (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
//   script.onload = ShopifyBuyInit;
// }

// function ShopifyBuyInit() {
//   var client = ShopifyBuy.buildClient({
//     domain: 'havalab.com',
//     storefrontAccessToken: 'e13f5b2fb3e174f6cc5d3ecc6d2a5975',
//   });
//   let presellProduct = document.querySelectorAll('.hava-checkout-btn');
//   presellProduct.forEach(item => {
//     let id = $(item).data('productid');
//     let lang = $(item).data('lang');
//     let btnstr = 'btn-' + lang;
//     let checkoutBtn = $(item).data(btnstr);
//     ShopifyBuy.UI.onReady(client).then(function (ui) {
//       console.log(id, checkoutBtn)
//       ui.createComponent('product', {
//         id: id,
//         node: document.getElementById(`product-component-${id}`),
//         moneyFormat: '%24%7B%7Bamount%7D%7D',
//         options: {
//           "product": {
//             iframe: false,
//             "buttonDestination": "checkout",
//             "contents": {
//               "img": false,
//               "title": false,
//               "price": false
//             },
//             "classes": {
//               button: "presell-checkout"
//             },
//             "text": {
//               "button": checkoutBtn
//             }
//           }
//         }
//       });
//     });
//   })

// }

$('.active-checkout-btn').click(function () {
  const variantId = $(this).data('variantid');
  
  const mutation = `
    mutation {
      cartCreate(
        input: {
          lines: [
            {
              quantity: 1
              merchandiseId: "gid://shopify/ProductVariant/${variantId}"
            }
          ]
        }
      ) {
        cart {
          id
          checkoutUrl
        }
      }
    }
  `;

  fetch('/api/2025-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'bcbe3ab8d08f755356aec2805dc3882f'
    },
    body: JSON.stringify({ query: mutation })
  })
  .then(response => response.json())
  .then(result => {
    if (result.data && result.data.cartCreate && result.data.cartCreate.cart) {
      window.location.href = result.data.cartCreate.cart.checkoutUrl;
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
});